import React from 'react';

import { Header } from './components/Header/Header';
import { HeroContent } from './components/HeroContent/HeroContent';
import { ContactUs } from './components/Contact/ContactUs';
import { Faq } from './components/Faq/Faq';
import { FeaturesCards } from './components/FeaturesSection/FeaturesCards';
import { Footer } from './components/Footer/Footer';
import { AdvantagesGrid } from './components/AdvantagesSection/Advantages';
import { Requirements } from './components/Requirements/Requirements';
import { WhatsAppButton } from './components/WhatsAppButton/WhatsAppButton';

export default function App() {
  return (
    <div style={{ backgroundColor: '#f6f4f5' }}>
      <Header />
      <WhatsAppButton />
      <HeroContent />
      <AdvantagesGrid />
      <FeaturesCards />
      <Requirements />
      <Faq />
      <ContactUs />
      <Footer />
    </div>
  );
}
